window.AcompanhamentoController = ControllerBase.extend({
    name: "AcompanhamentoController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {

            var cliente = this.cliente
                 ? this.cliente
                 : ControllerBase.instances['CadastroClienteController'].model;

            return this.toJS(cliente);
        },
    }),

    ajax: function() {

        return {
            url: "/Cliente/_Acompanhamento",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisa: this.pesquisa
            })
        };
    },

    renderizado: function() {

        $("#acompanhamento-container").removeClass("none").addClass("separador");

        this.AcompanhamentoView = this.showView({
            region: {
                name: "acompanhamentoViewRegion",
                selector: "#acompanhamento-region"
            },
            view: {
                type: AcompanhamentoView,
                args: {
                    collection: new Acompanhamentos(this.model)
                }
            }
        });
    }
});